import ControlEntities from "@impero-com/common/img/control-entities-icon.svg";
import ControlEntitiesLocked from "@impero-com/common/img/control-entities-locked.svg";
import ControlManagement from "@impero-com/common/img/control-management.svg";
import ControlTesting from "@impero-com/common/img/control-testing.svg";
import HomeIcon from "@impero-com/common/img/home.svg";
import ImperoShare from "@impero-com/common/img/impero-share.svg";
import Reports from "@impero-com/common/img/reports.svg";
import RiskModule from "@impero-com/common/img/risk-module.svg";
import TagsManagement from "@impero-com/common/img/tag-management-icon.svg";
import Users from "@impero-com/common/img/users.svg";
import type { TFunction } from "@impero-com/common/utils/i18n";

import { LegacyRoute } from "../../legacyRoutes";
import { WebRoute } from "../../routes";
import { controlEntitiesListUrl } from "../controlEntities/urlUtils";
import { testingProgramListUrl } from "../controlTesting/urlUtils";

export type NavFeatureFlag =
    | "controlTesting"
    | "imperoShare"
    | "controlEntities";

export interface NavItem {
    readonly id: string;
    readonly label: string;
    readonly icon?: string;
    readonly lockedIcon?: string;
    readonly href?: string;
    readonly featureFlag?: NavFeatureFlag;
    readonly lockedWhenFlagOff?: boolean;
}

export function buildFlatNavTree(t: TFunction): readonly NavItem[] {
    return [
        {
            id: "dashboard",
            label: t("Dasboard_MenuTitle"),
            icon: HomeIcon,
            href: WebRoute.HOME,
        },
        {
            id: "controlManagement",
            label: t("ControlManagement_ModuleTitle"),
            icon: ControlManagement,
            href: WebRoute.CONTROLS,
        },
        {
            id: "controlTesting",
            label: t("ControlTesting_ModuleTitle"),
            icon: ControlTesting,
            href: testingProgramListUrl,
            featureFlag: "controlTesting",
        },
        {
            id: "imperoShare",
            label: t("ControlTemplate_MenuTitle"),
            icon: ImperoShare,
            href: LegacyRoute.SHARE,
            featureFlag: "imperoShare",
        },
        {
            id: "userManagement",
            label: t("User_MenuTitle"),
            icon: Users,
            href: WebRoute.USERS,
        },
        {
            id: "reports",
            label: t("Report_MenuTitle"),
            icon: Reports,
            href: WebRoute.REPORTS,
        },
        {
            id: "riskManagement",
            label: t("RiskModule_MenuTitle"),
            icon: RiskModule,
            href: WebRoute.RISKS,
        },
        {
            id: "entities",
            label: t("Entities_MenuTitle"),
            icon: ControlEntities,
            lockedIcon: ControlEntitiesLocked,
            href: controlEntitiesListUrl,
            featureFlag: "controlEntities",
            lockedWhenFlagOff: true,
        },
        {
            id: "tags",
            label: t("TagManagement_MenuTitle"),
            icon: TagsManagement,
            href: WebRoute.TAGS,
        },
    ];
}
